export const EXPIRY = {
  default: 2,
  defaultLast: 3,
  times: [
    'Default',
    '3 Hours',
    '24 Hours',
    '1 Week',
    '1 Month',
    'Never'
  ]
}



// WEBPACK FOOTER //
// ../webmango-core/selectors/expiry.js